import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Question, QuestionStatusEnum } from 'src/app/shared/models/account-recovery/accoun-recovery-question';
import { BaseModalService } from 'src/app/shared/services/base-modal.service';
import { PasswordRecoveryService } from 'src/app/shared/services/password-recovery.service';
import { ToastService } from 'src/app/shared/toast';

@Component({
  selector: 'app-account-recovery',
  templateUrl: './account-recovery.component.html',
  styleUrls: ['./account-recovery.component.scss']
})
export class AccountRecoveryComponent implements OnInit, OnDestroy {

  currentQuestion: Question;
  selectedAnswer: any;
  answerStepFeedback = ['help', 'help', 'help'];
  answerQuestionsCount = 0;
  wrongAnswerCount = 0;
  lastestToken: string;
  loading = false;
  isMinorThanTablet: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 768px)');

  @Input()
  isInternal = false;

  @Input()
  pathToRedirectOnErrorOrCancel = '/';

  @Output()
  onAccountVerificationCompleted: EventEmitter<any> = new EventEmitter<any>()

  constructor(
    private passwordRecoveryService: PasswordRecoveryService,
    private toastService: ToastService,
    private baseModalService: BaseModalService,
    private router: Router,
    public breakpointObserver: BreakpointObserver,
  ) { }

  ngOnInit(): void {
    if (sessionStorage.getItem('feedbackIcons')) {
      this.answerStepFeedback = JSON.parse(sessionStorage.getItem('feedbackIcons'))
    }

    if (sessionStorage.getItem('feedbackIconsCount')) {
      this.answerQuestionsCount = parseInt(sessionStorage.getItem('feedbackIconsCount'))

    }

    this.getRecoveryQuestion();
  }

  ngOnDestroy(): void {
    sessionStorage.removeItem('feedbackIcons')
    sessionStorage.removeItem('feedbackIconsCount')
  }

  async getRecoveryQuestion() {
    try {
      const res = await this.passwordRecoveryService.getRecoveryQuestion(this.isInternal);
      if (res.status === QuestionStatusEnum.FINALIZADO) {
        if (!this.lastestToken) {
          return this.showBlockModal();
        }

        this.passwordRecoveryService.setSecretKey({ secret: res.secret, token: this.lastestToken });

        if (this.isInternal) {
          return this.onAccountVerificationCompleted.emit();
        }

        this.router.navigate(['/recuperar-senha/alterar']);
        return;
      }
      this.currentQuestion = res.pergunta;
    } catch (res) {
      if (res.error?.type === 'CADASTRO_INSUFICIENTE') {
        this.showInsufficientRegistrationModal()
      }
      if (res.error?.message && res.error?.message.includes(QuestionStatusEnum.BLOQUEADO)) {
        this.showBlockModal();
      }
    }
  }

  handleSelectAwnser(answer: string) {
    this.selectedAnswer = answer;
  }

  async handleNextQuestion() {
    try {
      this.loading = true;
      const res = await this.passwordRecoveryService.sendRecoveryQuestionAnswer({
        pergunta: { id: this.currentQuestion.id },
        resposta: { id: this.selectedAnswer },
      }, this.isInternal);

      if (!res.retorno) {
        this.wrongAnswerCount++
        this.toastService.show({ title: 'Resposta errada.', text: 'Você precisa de 3 acertos para avançar.', type: 'error' });
      }

      this.selectedAnswer = null;
      this.answerStepFeedback[this.answerQuestionsCount] = res.retorno ? 'check_circle' : 'cancel';
      this.answerQuestionsCount++;
      sessionStorage.setItem('feedbackIcons', JSON.stringify(this.answerStepFeedback));
      sessionStorage.setItem('feedbackIconsCount', this.answerQuestionsCount.toString());
      this.lastestToken = res.token;
      this.getRecoveryQuestion();
    } catch (error) {
      this.toastService.show({ title: 'Houve um erro ao processar a resposta.', text: 'Tente novamente mais tarde.', type: 'error' });
    } finally {
      this.loading = false;
    }
  }

  showBlockModal() {
    this.baseModalService.showConfirmationModal({
      text: 'Tente novamente em <strong>24 horas.</strong>',
      confirmBtnText: 'Ok, entendi',
      hideDeniedButton: true,
      disableClose: true,
    }).afterClosed().subscribe(() => this.router.navigate([this.pathToRedirectOnErrorOrCancel]));
  }

  showInsufficientRegistrationModal() {
    this.baseModalService.showConfirmationModal({
      text: 'Por favor, compareça a uma loja Casas Bahia para <strong>atualizar o seu cadastro.</strong>',
      confirmBtnText: 'Ok, entendi',
      hideDeniedButton: true,
      disableClose: true,
    }).afterClosed().subscribe(() => this.router.navigate([this.pathToRedirectOnErrorOrCancel]));
  }

  geIconColorClass(iconName: string) {
    const iconColorClassMap = {
      help: 'help-icon',
      'check_circle': 'success-icon',
      cancel: 'error-icon'
    }

    return iconColorClassMap[iconName];
  }

  handleCancel() {
    this.router.navigate([this.pathToRedirectOnErrorOrCancel], { state: { confirmDeactivate: true } });
  }

}
